/** Public sofa fallback when Console has no login background URL. */
export const LOGIN_SOFA_BG_SRC = '/static/login-sofa-bg.jpg';

const isUsableUrl = value =>
  typeof value === 'string' &&
  (value.startsWith('/') || value.startsWith('https://') || value.startsWith('http://'));

/**
 * Pull a display URL from Console branding loginBackgroundImage.
 * Accepts an imageAsset, a raw string URL, or null.
 *
 * @param {Object|string|null|undefined} image
 * @returns {string|null}
 */
export const loginBackgroundUrlFromAsset = image => {
  if (isUsableUrl(image)) {
    return image;
  }
  const variants = image?.attributes?.variants;
  if (!variants || typeof variants !== 'object') {
    return null;
  }
  const preferred =
    variants.scaled1200 || variants.scaled800 || variants.scaled2400 || variants.scaled;
  if (isUsableUrl(preferred?.url)) {
    return preferred.url;
  }
  const first = Object.values(variants).find(variant => isUsableUrl(variant?.url));
  return first?.url || null;
};

/**
 * Hosted Console login background if present, else the static sofa asset.
 *
 * @param {Object} [branding]
 * @returns {string}
 */
export const resolveLoginBackgroundUrl = branding => {
  const hosted =
    loginBackgroundUrlFromAsset(branding?.loginBackgroundImageUrl) ||
    loginBackgroundUrlFromAsset(branding?.loginBackgroundImage) ||
    loginBackgroundUrlFromAsset(branding?.loginBackground);
  return hosted || LOGIN_SOFA_BG_SRC;
};
